import { Connection } from './pages';

export default {
  key: 'connection',
  isPrivate: true,
  exact: true,
  path: '/connection',
  component: Connection,
};
